<template>
  <!-- //TODO precisa ser componentizado com a pagina de edição de template sms -->
  <div class="dataTable py-5 mt-3" style="padding: 80px">
    <CRow class="pt-5 pb-4">
      <CCol sm="12" class="d-flex flex-column">
        <div>
          <h1 class="titlePage font-weight-normal text-capitalize">
            {{ $t('templates.sms.create.title') }}
          </h1>
          <CCol sm="12" class="mb-2 p-0 mt-5">
            <a
              @click="$router.go(-1)"
              class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600"
              style="cursor: pointer"
            >
              <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />BACK TO TEMPLATES
            </a>
          </CCol>
        </div>
      </CCol>
    </CRow>
    <CRow class="my-4">
      <CCol sm="12">
        <CRow class>
          <CCol class="h-100" style>
            <h5 class>{{ $t('templates.sms.create.label.name') }}</h5>
            <div class="border-line"></div>
          </CCol>
        </CRow>
        <CRow class="mb-4 mt-3">
          <CCol md="4" sm="12" style>
            <CInput type="text" maxlength="255" :value.sync="templateName" addLabelClasses="mb-0 required" placeholder="WRITE A NAME" />
          </CCol>
        </CRow>
      </CCol>
      <CCol md="6" sm="12">
        <CRow>
          <CCol class="h-100">
            <label class="font-xl font-weight-bold mb-0">
              {{ $t(`templates.sms.create.label.message`) }}
              <span class="text-danger">*</span>
            </label>
          </CCol>
        </CRow>
        <CRow class="mb-4 mt-3">
          <CCol md="12" sm="12" style>
            <SMSTemplateTextarea
              :is-message-invalid="$v.smsMessage.$invalid && $v.smsMessage.$dirty"
              :message-invalid-feedback="invalidFeedbackSMSMessage"
              :loaded-message-text="smsMessage"
              :added-custom-field="addedCustomField"
              @message-changed="handleSMSMessageChanged"
            />
            <div class="mt-5">
              <CButton @click="createTemplatesSMS" :disabled="isCreateButtonDisabled" class="btn btn-primary text-uppercase">{{
                $t('templates.sms.create.buttom-create')
              }}</CButton>
              <CButton @click="$router.go(-1)" class="btn btn-defaut ml-2 text-uppercase">{{ $t('templates.sms.create.buttom-cancel') }}</CButton>
            </div>
          </CCol>
        </CRow>
      </CCol>
      <CCol md="6" sm="12" class="pl-5">
        <CRow class>
          <CCol class="h-100">
            <h5 class>Custom Fields</h5>
            <div class="border-line"></div>
          </CCol>
        </CRow>
        <CRow class="mb-4 mt-3">
          <CCol md="8" sm="12">
            <CRow :gutters="false" class="d-flex align-items-center mb-2">
              <CCol sm="9">
                <multiselect
                  v-model="selectedCustomField"
                  :multiple="false"
                  :options="customFieldsList"
                  :customLabel="customLabel"
                  custom
                  ref="textAreaCustom"
                  class="multiselect--custom"
                  :allow-empty="false"
                  :show-labels="false"
                  :placeholder="$t('templates.sms.placeholder.select')"
                >
                </multiselect>
              </CCol>

              <CCol sm="2" class="ml-2">
                <CButton type="button" class="btn btn-primary py-2 text-uppercase" :disabled="!selectedCustomField" @click="addCustomField()">
                  {{ $t('templates.sms.create.field-custom.buttom-add') }}</CButton
                >
              </CCol>
            </CRow>
          </CCol>
          <CCol md="8" sm="12" class="mt-4">
            <span class="text-gray-600 font-20">
              {{ $t('templates.sms.create.description') }}
            </span>
          </CCol>
        </CRow>
      </CCol>
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
    </CRow>
  </div>
</template>

<script>
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
import SMSTemplateTextarea from '@/components/SMSTemplateTextarea.vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
const CUSTOM_GROUP = 'CUSTOM'

export default {
  name: 'TemplateSmsCreate',
  mixins: [validationMixin],
  components: { MenssageAlert, SMSTemplateTextarea },
  data() {
    return {
      loading: false,
      addedCustomField: undefined,
      selectedCustomField: undefined,
      customFieldsList: [],
      templateName: '',
      smsMessage: '',
      messages: [],
      isMsgCharsAvailableNegative: false,
    }
  },

  validations: {
    smsMessage: { required },
    isMsgCharsAvailableNegative: { checked: (value) => value === false },
  },

  mounted() {
    this.getSchema()
  },

  computed: {
    invalidFeedbackSMSMessage() {
      if (!this.$v.smsMessage.required) return this.$t('templates.sms.create.validations.feedback.required')

      return this.$t('templates.sms.create.validations.feedback.error')
    },
    isCreateButtonDisabled() {
      return this.loading || this.$v.$invalid
    },
  },

  methods: {
    createTemplatesSMS() {
      this.messages = []
      this.loading = true
      let body = {
        templateContent: this.smsMessage,
        name: this.templateName,
      }
      let organizationId = this.$store.state.auth.organizationId

      services
        .createTemplatesSMS(organizationId, body)
        .then(() => {
          this.messages.push({
            status: 'success',
            text: this.$t('templates.sms.create.message-success'),
          })
          this.$router.push({ name: 'template-sms' })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: this.$te(`general.errors.${response.data.message}`)
              ? this.$t(`general.errors.${response.data.message}`)
              : response.data.Message || 'ERROR',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    customLabel(option) {
      return `${option.value}`
    },

    async getSchema() {
      try {
        const FIELD_TYPES = await services.fieldtypes(this.$store.state.auth.organizationId)

        const SCHEME = await services.audienceSchema(this.$store.state.auth.organizationId)

        if (SCHEME.data.data.errorCode === 1000) {
          this.customFieldsList = [...this.handleCustomtypes(FIELD_TYPES)]
          throw 'AUDIENCE_SCHEMA_NOT_FOUND'
        }

        this.customFieldsList = [...SCHEME.data.data.values, ...this.handleCustomtypes(FIELD_TYPES)]
      } catch (error) {
        if (error.response.data.message == 'AUDIENCE_SCHEMA_NOT_FOUND') return
        this.messages.push({
          status: 'danger',
          text: error.response.data.Message || 'ERROR',
        })
      }
    },

    handleCustomtypes(FIELD_TYPES) {
      let CUSTOMS = FIELD_TYPES.data.data.groups.filter((group) => group.group == CUSTOM_GROUP)

      if (CUSTOMS[0].types.lenght) {
        return CUSTOMS.map((item, index) => {
          return {
            ...item.types[index],
            value: item.types[index].personalizationTag,
          }
        })
      }

      return []
    },

    addCustomField() {
      if (!this.selectedCustomField) return

      this.addedCustomField = this.selectedCustomField
      this.selectedCustomField = null

      setTimeout(() => {
        this.addedCustomField = null
      }, 100)
    },

    handleSMSMessageChanged(msgValue, isCharsAvailableNegative) {
      this.smsMessage = msgValue
      this.isMsgCharsAvailableNegative = isCharsAvailableNegative
      this.$v.smsMessage.$touch()
    },
  },
}
</script>

<style scope>
.form-control:focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgb(214 214 214 / 25%) !important;
  box-shadow: 0 0 0 0.2rem rgb(214 214 214 / 25%) !important;
  border-color: #efefef !important;
}
</style>
